var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading && !_vm.error)?_c('f7-preloader',{attrs:{"size":15}}):(!_vm.loading && _vm.error)?_c('div',[_vm._v("\n  Something went wrong...\n")]):_c('div',[_vm._t("default",null,{"data":_vm.data})],2)}
var staticRenderFns = []

export { render, staticRenderFns }